<template>
  <background>
    <search></search>
    <banner :bannerInfo="bannerInfo"></banner>
    <purchase></purchase>
    <brand :list="brandInfo"></brand>
    <GoodsList :list="list" :finished="finished" v-model="loading" @load="getGoodsList" :select-goods="routeTo"/>
    <ScrollTop></ScrollTop>
    <!-- <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="getGoodsList"
      >
        <productList :productlist="list" :showCart="false" :to-goods-detail="routeTo"></productList>
      </van-list> -->
  </background>
</template>
<script>
import GoodsList from '@/components/GoodsList';
import ScrollTop from '@/components/ScrollTop';
import search from '@/components/search';
import { background, banner, brand, purchase } from './components';

export default {
  components: {
    banner,
    purchase,
    brand,
    search,
    background,
    GoodsList,
    ScrollTop
  },
  data () {
    return {
      bannerInfo: [],
      brandInfo: [],
      list: [],
      loading: false,
      finished: false,
    }
  },
  methods: {
    // 获取banner图
    getBannerInfo () {
      for (let i = 0; i < 4; i++) {
        this.bannerInfo.push({
          banner_id: i,
          banner_pic: require('../../assets/cake/banner/蛋糕到家banner.png')
        })
      }
    },
    // 获取品牌列表
    getBrandInfo () {
      // 获取品牌信息
      this.brandInfo = [
        {
          cat_id: 0,
          cat_name: '奈雪的茶',
          cat_pic: require('../../assets/cake/brand/01.png')
        },
        {
          cat_id: 1,
          cat_name: '星巴克',
          cat_pic: require('../../assets/cake/brand/02.png')
        },
        {
          cat_id: 2,
          cat_name: '幸福西饼',
          cat_pic: require('../../assets/cake/brand/03.png')
        },
        {
          cat_id: 3,
          cat_name: '幸福西饼',
          cat_pic: require('../../assets/cake/brand/04.png')
        },
        {
          cat_id: 7,
          cat_name: '哈根达斯',
          cat_pic: require('../../assets/cake/brand/07.png')
        },
        {
          cat_id: 8,
          cat_name: 'DQ皇后',
          cat_pic: require('../../assets/cake/brand/08.png')
        },
        {
          cat_id: 9,
          cat_name: '爱心品',
          cat_pic: require('../../assets/cake/brand/09.jpg')
        },
          {
          cat_id: 10,
          cat_name: '好利来',
          cat_pic: require('../../assets/cake/brand/10.jpg')
        },
      ]
      // for (let i = 0; i < 8; i++) {
      //   this.brandInfo.push({
      //     cat_id: i,
      //     cat_name: 'starbucks',
      //     cat_pic: require(`@/assets/cake/brand/0${i+1}.png`)
      //   })
      // }
    },
    getGoodsList () {
      // this.loading = true
      this.list = [
        {
          "goods_sn": "178546",
          "goods_name": "黑金榴莲千层蛋糕",
          "goods_desc": "米卡米卡",
          "pic": require('@/assets/cake/goods/2.jpg'),
          "goods_sale": 1,
          "goods_price": "138.00",
          "goods_marketPrice": "0.00",
          "cat_name": "",
          "cat_id": 0
        },
        {
          "goods_sn": "178544",
          "goods_name": "梦幻粉少女梦蛋糕",
          "goods_desc": "许个愿吧",
          "pic": require('@/assets/cake/goods/1.jpg'),
          "goods_sale": 1,
          "goods_price": "169.00",
          "goods_marketPrice": "0.00",
          "cat_name": "",
          "cat_id": 0
        },
        {
          "goods_sn": "178555",
          "goods_name": "芒果椰奶千层蛋糕",
          "goods_desc": "米卡米卡",
          "pic": require('@/assets/cake/goods/4.jpg'),
          "goods_sale": 1,
          "goods_price": "138.00",
          "goods_marketPrice": "0.00",
          "cat_name": "",
          "cat_id": 0
        },
        {
          "goods_sn": "178555",
          "goods_name": "玫瑰草莓千层蛋糕",
          "goods_desc": "米卡米卡",
          "pic": require('@/assets/cake/goods/3.jpg'),
          "goods_sale": 1,
          "goods_price": "158.00",
          "goods_marketPrice": "0.00",
          "cat_name": "",
          "cat_id": 0
        },
        {
          "goods_sn": "178555",
          "goods_name": "蔓越莓提拉米苏复兴蛋糕",
          "goods_desc": "米卡米卡",
          "pic": require('@/assets/cake/goods/5.jpg'),
          "goods_sale": 1,
          "goods_price": "158.00",
          "goods_marketPrice": "0.00",
          "cat_name": "",
          "cat_id": 0
        },
         {
          "goods_sn": "178555",
          "goods_name": "星空芒果星辰蛋糕",
          "goods_desc": "米卡米卡",
          "pic": require('@/assets/cake/goods/6.jpg'),
          "goods_sale": 1,
          "goods_price": "158.00",
          "goods_marketPrice": "0.00",
          "cat_name": "",
          "cat_id": 0
        },
          {
          "goods_sn": "178555",
          "goods_name": "奥利奥芝士城堡蛋糕",
          "goods_desc": "米卡米卡",
          "pic": require('@/assets/cake/goods/7.jpg'),
          "goods_sale": 1,
          "goods_price": "158.00",
          "goods_marketPrice": "0.00",
          "cat_name": "",
          "cat_id": 0
        },
        {
          "goods_sn": "178555",
          "goods_name": "抹茶红豆园林蛋糕",
          "goods_desc": "米卡米卡",
          "pic": require('@/assets/cake/goods/8.jpg'),
          "goods_sale": 1,
          "goods_price": "158.00",
          "goods_marketPrice": "0.00",
          "cat_name": "",
          "cat_id": 0
        },
        {
          "goods_sn": "178555",
          "goods_name": "榴莲奶油皇冠状蛋糕",
          "goods_desc": "米卡米卡",
          "pic": require('@/assets/cake/goods/9.jpg'),
          "goods_sale": 1,
          "goods_price": "158.00",
          "goods_marketPrice": "0.00",
          "cat_name": "",
          "cat_id": 0
        }
      ]
      // this.loading = false;
      this.finished = true;
    },
    routeTo (info) {
      this.$router.push({
         name: 'CakeDetail',
          query: {
            pid: info.goods_sn,
          }
      })
    }
  },
  mounted () {
    this.getBannerInfo();
    this.getBrandInfo();
  }
}
</script>